//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../Routing/Routing.PortArrayListItemBuilderList.js";
import "../Routing/Routing.NamingPatternBuilder.js";
import "../no/ObjectList.js";
let d=[[[1,"ArrayPatternList",0,"Routing.PortArrayListItemBuilderList",0],[0,"ArrayType",1,0],[0,"NamingMethod",1,0],[0,"PatternCol",1,"Routing.NamingPatternBuilder",0],[0,"PatternRow",1,"Routing.NamingPatternBuilder",0],[0,"ReuseSuppressedNames",1,0],[0,"StartingCorner",1,0],[0,"StartingDirection",1,0]],[],[]];
SPLM.Routing.PortArraysBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.PortArraysBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Routing.PortArraysBuilder.ArrayTypes = Object.freeze({
    "Rectangular" : "Rectangular", "Circular" : "Circular"});

SPLM.Routing.PortArraysBuilder.NamingMethods = Object.freeze({
    "Clockwise" : "Clockwise", "Counterclockwise" : "Counterclockwise", "Across" : "Across", "Continuous" : "Continuous", "RowCol" : "RowCol"});

SPLM.Routing.PortArraysBuilder.StartingCorners = Object.freeze({
    "BottomLeft" : "BottomLeft", "BottomRight" : "BottomRight", "UpperLeft" : "UpperLeft", "UpperRight" : "UpperRight"});

SPLM.Routing.PortArraysBuilder.StartingDirections = Object.freeze({
    "Horizontal" : "Horizontal", "Vertical" : "Vertical"});

export default SPLM;